import Formulario from "../../../components/Formulario";
import close_icon from "../../../../assets/icons/close.svg";
import { tiposGerenciamentoModal } from "../../../../utils/data";
import Select from "../../../components/Select";
import { Main } from "../styled";
import {useState} from "react";
import { useSelector } from "react-redux";
import Usuario from "../../../../models/Usuario";
import { useEffect } from "react";
import AlertDialog from "../../../components/AlertDialog";
import Loading from "../../../components/Loading";
import ValidacaoUsuario from "./validacao";
import Validacao from "../../validacao";
import DeleteDialog from "../../../components/DeleteDialog";
import { mensagemDeErro, respostaOk } from "../../../../utils/resposta";

function UsuariosModal({tipo, onClose, usuario, setUsuario}){
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [usuarios, setUsuarios] = useState({});
  const [errors, setErrors] = useState({});
  const [showOptions, setShowOptions] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showResetSenha, setShowResetSenha] = useState(false);
  const [loading, setShowLoading] = useState(false);
  const logado = useSelector((state) => state.usuario);
  // Papel escolhido no select, ainda não salvo.
  const [tipoSelecionado, setTipoSelecionado] = useState("");
  const ehOProprio = !!usuario.id && Number(usuario.id) === Number(logado?.id);

  async function filtrarUsuarios(e) {
    const searchValue = e.target.value;
    setNomeUsuario(searchValue);

    let newUsuarios = [];

    if (searchValue) {
      newUsuarios = await Usuario.findSearch(searchValue);
    } else {
      newUsuarios = await Usuario.findAll();
    }

    setUsuarios(newUsuarios.data);
  }

  function onClickSelectUsuario(usuario) {
    setNomeUsuario(usuario.nome);
    setUsuario(usuario);
    setErrors((prevErrors) => ({ ...prevErrors, usuarios: '' }));
  }

  
  function validar(e, handle) {
    handle(e, usuario, errors, setUsuario, setErrors);
  }

  // Muda o PAPEL pela rota própria do administrador (PATCH /usuarios/:id/tipo).
  // O POST /usuarios é o do cadastro/perfil e não serve para isso: o backend
  // só deixa o administrador alterar `tipo`, e nunca na própria conta.
  async function handleSalvarTipo(){
    setErrors((prevErrors) => ({ ...prevErrors, geral: '' }));

    if (!tipoSelecionado || tipoSelecionado === usuario.tipo) {
      setErrors((prevErrors) => ({ ...prevErrors, geral: 'Nenhuma alteração para salvar.' }));
      return;
    }

    setShowLoading(true);
    const result = await Usuario.alterarTipo(usuario.id, tipoSelecionado);
    if (respostaOk(result)) {
      setUsuario({ ...usuario, tipo: tipoSelecionado });
      setShowSuccess(true);
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, geral: mensagemDeErro(result) }));
    }
    setShowLoading(false);
  }

  async function handleSubmit(e){
    e.preventDefault();

    if (tipo !== tiposGerenciamentoModal.CRIAR) {
      return handleSalvarTipo();
    }
    
    const formulario = document.getElementById('form-usuario');
    const input_errors = Validacao.validarCampos(formulario, errors, setErrors);
    setErrors(input_errors);
    if (Validacao.emptyErrors(input_errors)) {
      setShowLoading(true);
      const result = await Usuario.create(usuario);
      if (result.response) {
        const data = result.response.data;

        if (data.field) {
          setErrors((prevErrors) => ({ ...prevErrors, [data.field]: data.error }));
          document.getElementById(data.field)?.focus();
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, geral: data.error }));
        }
      }else{
        setShowSuccess(true);
        setNomeUsuario(usuario.nome);
      }
      setShowLoading(false);
    }
  }

  async function handleDelete(){

    setShowLoading(true);
    const result = await Usuario.delete(usuario.id);
    if (result.response) {
      const data = result.response.data;
      setErrors((prevErrors) => ({ ...prevErrors, delete: data.error }));
    }else{
      window.location.reload();
    }
    setShowLoading(false);
    
  }

  /**
   * Dispara o e-mail de redefinicao para o usuario selecionado.
   *
   * O administrador NUNCA ve nem escolhe a senha: quem refaz e a propria
   * pessoa, pelo link do e-mail (valido por 1 hora). O metodo ja existia no
   * model, usado pela tela publica de "esqueci minha senha" -- aqui e a mesma
   * rota, so acionada pelo painel.
   */
  async function handleResetSenha(){
    setErrors((prevErrors) => ({ ...prevErrors, reset_senha: '' }));
    setShowLoading(true);

    const result = await Usuario.solicitarRedefinirSenha({ email: usuario.email });

    if (result.response) {
      const data = result.response.data;
      // 429 vem do limite de taxa da rota (LimiteTaxa.js no backend) e traz
      // 'message'; os demais erros do painel usam 'error'.
      setErrors((prevErrors) => ({
        ...prevErrors,
        reset_senha: data.message || data.error || 'Não foi possível enviar o e-mail. Tente novamente.'
      }));
    } else {
      setShowResetSenha(true);
    }

    setShowLoading(false);
  }

  function limparCampos(){
    setNomeUsuario("");
    setUsuario({});
  }

  function handleSuccessButton(){
    setShowSuccess(false);
    if(tipo === tiposGerenciamentoModal.CRIAR){
      limparCampos();
    }else{
      // findAllUsuarios();
    }
  }

  useEffect(()=>{
    setNomeUsuario(usuario.nome);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Trocou de usuário (ou salvou): o select volta a refletir o papel real.
  useEffect(()=>{
    setTipoSelecionado(usuario.tipo || "");
  }, [usuario.id, usuario.tipo]);

  return(
    <>
      {tipo !== tiposGerenciamentoModal.NONE  &&
        <Main>
          {loading && <Loading titulo={"Aguarde um momento"} subtitulo={"Estamos validando suas informações"}/>}
          {showSuccess && 
            <AlertDialog 
              titulo={`Usuario ${usuario.id ? 'atualizado' : 'cadastrado'} com sucesso!`} 
              buttonText={`${usuario.id ? 'Voltar' : 'Cadastrar novo usuario'}`} 
              buttonOnClick={handleSuccessButton}
            />
          }
          {showResetSenha &&
            <AlertDialog
              titulo={`Link de redefinição enviado para ${usuario.email}. Ele expira em 1 hora.`}
              buttonText="Voltar"
              buttonOnClick={()=>setShowResetSenha(false)}
            />
          }
          { showDelete && 
              <DeleteDialog
                error={errors.delete}
                titulo="Deseja realmente excluir esse usuario?" 
                subtitulo="Todos os dados, plantios e postagens deste usuários seram excluídos de forma permanente."
                onDelete={handleDelete} 
                onClose={()=>setShowDelete(false)}
              />
            }
          <div className="content-modal">
            <div className="top">
              <h3>Usuarios</h3>
              <button type="button" onClick={()=>{limparCampos(); onClose()}}>
                <img src={close_icon} alt="Icone de fechar"/>
              </button>
            </div>
            
            <h4>
              Editar ou excluir um usuário
            </h4>
            <Formulario id="form-usuario">
              { tipo === tiposGerenciamentoModal.EDITAR &&
                <div className="form-group">
                  <label htmlFor="usuarios">Lista de usuarios</label>
                  <Select 
                    id="usuarios" 
                    name="usuarios" 
                    placeholder="Pesquise por usuarios aqui" 
                    required={false}
                    autoComplete="off"
                    value={nomeUsuario} 
                    onChange={filtrarUsuarios} 
                    className={`input-prefix ${errors.usuarios && 'input-error'}`}
                    options={usuarios.rows}
                    onClickOption={onClickSelectUsuario}
                    showOptions={showOptions}
                    setShowOptions={setShowOptions}
                  />
                  <span className="error">{errors.usuarios}</span>
                </div>
              }

<div className="form-group">
                <label htmlFor="nome">Nome do usuário</label>
                <input 
                  required
                  value={usuario.nome || ""} 
                  type="text" 
                  name="nome" 
                  id="nome"
                  disabled
                  placeholder={tipo === tiposGerenciamentoModal.EDITAR ? "Escolha um usuario" : "Digite o nome do novo usuario"}
                />
                <span className="error">{errors.nome}</span>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email do usuário</label>
                <input 
                  required
                  value={usuario.email || ""} 
                  type="text" 
                  name="email" 
                  id="email"
                  disabled
                  placeholder={tipo === tiposGerenciamentoModal.EDITAR ? "Escolha um usuario" : "Digite o nome do novo usuario"}
                />
                <span className="error">{errors.nome}</span>
              </div>

              <div className="form-group">
                <label htmlFor="estado">Estado do usuário</label>
                <input 
                  required
                  value={usuario.estado || ""} 
                  type="text" 
                  name="estado" 
                  id="estado"
                  disabled
                  placeholder={tipo === tiposGerenciamentoModal.EDITAR ? "Escolha um usuario" : "Digite o nome do novo usuario"}
                />
                <span className="error">{errors.nome}</span>
              </div>

              <div className="form-group">
                <label htmlFor="cidade">Cidade do usuário</label>
                <input 
                  required
                  value={usuario.cidade || ""} 
                  type="text" 
                  name="cidade" 
                  id="cidade"
                  disabled
                  placeholder={tipo === tiposGerenciamentoModal.EDITAR ? "Escolha um usuario" : "Digite o nome do novo usuario"}
                />
                <span className="error">{errors.nome}</span>
              </div>


              <div className="form-group">
                <label htmlFor="tipo">Tipo de usuário</label>
                <select id="tipo" disabled={!usuario.id || ehOProprio} name="tipo" value={tipoSelecionado}
                  onChange={(e)=>{ setTipoSelecionado(e.target.value); setErrors((prevErrors) => ({ ...prevErrors, geral: '' })); }}>
                  <option value="" disabled>Escolha um usuário</option>
                  <option value="Profissional">Profissional</option>
                  <option value="Comum">Comum</option>
                  <option value="Administrador">Administrador</option>
                </select>
                {ehOProprio && <span className="error">Você não pode alterar o tipo da própria conta.</span>}
              </div>
          
              <div className="form-group">
                
                <button disabled={(tipo === tiposGerenciamentoModal.EDITAR && !usuario.id) || ehOProprio} className="save-button" 
                  type="button" onClick={handleSubmit}
                >
                  Salvar edição
                </button>
                <span className="error">{errors.geral}</span>
              </div>

             {tipo === tiposGerenciamentoModal.EDITAR &&
                <div className="form-group">
                  <button disabled={!usuario.id} className="reset-senha-button" onClick={handleResetSenha} type="button">Enviar link de redefinição de senha</button>
                  <span className="error">{errors.reset_senha}</span>
                  <button disabled={!usuario.id} className="remove-button" onClick={()=>setShowDelete(true)} type="button">Excluir usuario</button>
                </div>
              }
            </Formulario>             
          </div>
        </Main>
      }
    </>
  );
};

export default UsuariosModal;